import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import ShoppableStorefrontProduct from './ShoppableStorefrontProduct';
import Ad from '../../../Ad';
import { isValid, decodeSpecialCharacters } from '../../../../utils';
import { APP_ENV } from '../../../../consts';
import './shoppable-storefront.scss';

const ShoppableStorefront = ({ 
  id,
  data,
  isMobile,
  isClient,
  hasAds,
  category,
  sponsorship,
  adType,
  isWowShop=false,
  isWowShopFeatured,
  isWowtextDeals,
  isScroll,
  isSpotlightQuiz,
}) => {
  console.log(data.products);
  if (!isValid(data) || !isValid(data.products) || data.products.length === 0 || !isValid(data.products[0])) {
    return null;
  }
  
  const ref = useRef(null);
  const { hed, hedBody, products } = data;
  const decodedHedBody = decodeSpecialCharacters(hedBody);
  let insertIndex = 12;
  let adCount = 0;
  let slotId = `purewow_shoppable_grid_${adCount}`;
  const adUnit = `purewow/${category}/article`;
  let renderedProducts;

  const scroll = (shift) => {
    ref.current.scrollLeft += shift;
  };

  if (isWowShopFeatured) {
    renderedProducts = (
      <div className='storefront-products'>
        <div className='featured-product'>
          <Fragment>
            <ShoppableStorefrontProduct
              product={products[0]}
              key={products[0].mediaId}
              isMobile={isMobile}
              isWowShop={isWowShop}
            />
          </Fragment>
        </div>
        <div className='products-grid'>
          {products.slice(1).map((product, i) => {
            const insertAd = hasAds && i + 1 === insertIndex;
            if (insertAd) {
              insertIndex += 12;
            }
            return (
                <Fragment>
                  <ShoppableStorefrontProduct
                      product={product}
                      key={product.mediaId}
                      isMobile={isMobile}
                      isWowShop={isWowShop}
                  />
                  {insertAd && 
                    <div className='htlad-purewow_shoppable_grid shoppable-grid-ad'
                      data-unit={adUnit}
                      data-targeting='{"slot_name":"purewow_shoppable_grid"}'></div>
                  }
                </Fragment>
            );
          })}
        </div>
      </div>
    );
  } else {
    renderedProducts = (
      <div className='storefront-products' ref={ref}>
        {products.map((product, i) => {
          const insertAd = hasAds && i + 1 === insertIndex;
          if (insertAd) {
            insertIndex += 12;
          }
          return (
            <Fragment>
              <ShoppableStorefrontProduct
                product={product}
                key={product.mediaId}
                isMobile={isMobile}
                isWowShopFeatured={isWowShopFeatured}
                isWowShop={isWowShop}
              />
              {insertAd && 
                <div className='htlad-purewow_shoppable_grid shoppable-grid-ad'
                    data-unit={adUnit}
                     data-targeting='{"slot_name":"purewow_shoppable_grid"}'></div>
              }
            </Fragment>
          );
        })}
      </div>
    );
  }
  return (
    <div className='shoppable-storefront'>
      {isScroll && <div className='arrow left' onClick={() => scroll(-500)}></div>}
      {isWowtextDeals ? (
        <div className='shoppable-storefront-title'>
          <p className='wowtext'>wowtext</p>
          <p className='deals'>deals</p>
        </div>
      ) : (
        <div className='shoppable-storefront-title'>{hed}</div>
      )}
      <div
        className='shoppable-storefront-hedBody'
        dangerouslySetInnerHTML={{ __html: decodedHedBody }}
      ></div>
      {!isSpotlightQuiz && <div className='hr-rule'></div>}
      {renderedProducts}
      {isScroll && <div className='arrow right' onClick={() => scroll(500)}></div>}
    </div>
  );
};

ShoppableStorefront.propTypes = {
  data: PropTypes.array,
};

export default ShoppableStorefront;
